<template>
  <div class="SmallSectionTitle">
    <div
      v-if="sectionNumber"
      class="section-number h-5-bold text-center"
    >
      {{ sectionNumber }}
    </div>
    <div
      class="h-2-bold h-5-bold"
      :class="{
        'app-color-2': color === 'blue',
        'app-color-black': color === 'black',
      }"
    >
      {{ title }}
    </div>
  </div>
</template>

<script type="text/javascript">
  export default {
    props: {
      sectionNumber: {
        type: [String, Number,],
        default: '',
      },
      title: {
        type: String,
        default: '',
      },
      color: {
        type: String,
        default: 'black',
      },
    },
  }
</script>

<style lang="scss">
.SmallSectionTitle {
  & > div {
    display: inline-block;
  }

  .section-number {
    height: 24px;
    width: 24px;
    border-radius: 4px;
    background-color: $color-94_94_94_16;
    margin-right: 15px;
  }
}
</style>
